import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { MultiSelect } from '@cyberint/stateful-ui/victimology/VictimologyTable/components/FiltersContainer/components/Filters/components/MultiSelect';
import { victimologyState } from '@cyberint/stateful-ui/victimology/VictimologyTable/store/atoms';
import { SECTOR, ORGANIZATION, COUNTRY, REGION } from '@cyberint/stateful-ui/victimology/VictimologyTable/utils';
import { mapDataToFilters } from './utils';
import * as S from './styled';

export const Filters = () => {
  const victimologyData = useAtomValue(victimologyState);
  const { organizations, sectors, countries, regions } = useMemo(
    () => mapDataToFilters(victimologyData || []),
    [victimologyData]
  );

  return (
    <S.Container>
      <div>
        <MultiSelect accessor={ORGANIZATION} options={organizations} />
        <MultiSelect accessor={SECTOR} options={sectors} />
      </div>
      <div>
        <MultiSelect accessor={COUNTRY} options={countries} />
        <MultiSelect accessor={REGION} options={regions} />
      </div>
    </S.Container>
  );
};
